import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "app-buscador",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./buscador.component.html",
  host: { class: "flex flex-col h-full min-h-0" }
})
export class BuscadorComponent {}
